// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `Reset and Base Styles * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
}

.notification-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border-radius: 20px;
  color: white;
  box-shadow: 0 10px 25px rgba(245, 158, 11, 0.2);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.bell-container {
  position: relative;
}

.header-icon {
  width: 2.5rem;
  height: 2.5rem;
}

.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  border: 2px solid white;
}

.title-content h1 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.subtitle {
  font-size: 1rem;
  opacity: 0.9;
  margin: 0.25rem 0 0 0;
}

.mark-all-read-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
}

.mark-all-read-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.notification-filters {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  background: white;
  padding: 0.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-btn {
  flex: 1 1;
  padding: 0.75rem 1rem;
  background: transparent;
  color: #64748b;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.filter-btn:hover {
  background: #f1f5f9;
  color: #475569;
}

.filter-btn.active {
  background: #f59e0b;
  color: white;
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}

.notification-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.notification-item {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.notification-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e1;
}

.notification-item.unread {
  border-left: 4px solid #f59e0b;
  background: linear-gradient(90deg, #fffbeb 0%, #ffffff 100%);
}

.notification-item.high {
  border-left-color: #ef4444;
}

.notification-item.lead_alert {
  border-top: 3px solid #f59e0b;
}

.notification-content {
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.notification-main {
  display: flex;
  gap: 1rem;
  flex: 1 1;
}

.notification-icon-wrapper {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
}

.notification-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.notification-icon.success {
  color: #16a34a;
}

.notification-icon.warning {
  color: #f59e0b;
}

.notification-icon.error {
  color: #ef4444;
}

.notification-icon.info {
  color: #3b82f6;
}

.notification-details {
  flex: 1 1;
  min-width: 0;
}

.notification-title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  gap: 1rem;
}

.notification-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  line-height: 1.4;
}

.notification-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.notification-time {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
}

.time-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.priority-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.priority-badge.high {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.lead-alert-details {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.lead-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 1rem;
}

.lead-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.lead-icon {
  width: 1rem;
  height: 1rem;
  color: #64748b;
}

.lead-name-text {
  font-weight: 600;
  color: #1e293b;
  font-size: 1rem;
}

.lead-status {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.status-followup {
  background: #fef3c7;
  color: #d97706;
  border: 1px solid #fde68a;
}

.status-interested {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.status-not-interested {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.status-callback {
  background: #dbeafe;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.status-default {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.remark-section {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.remark-label {
  font-weight: 600;
  color: #64748b;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.remark-text {
  color: #1e293b;
  font-size: 0.875rem;
  background: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  flex: 1 1;
}

.notification-description {
  color: #475569;
  margin-bottom: 1rem;
  line-height: 1.5;
  font-size: 0.9rem;
}

.notification-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.sender-info,
.notification-date {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  color: #64748b;
}

.sender-icon,
.date-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.sender-name {
  font-weight: 600;
}

.notification-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-left: 1rem;
}

.action-btn {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn svg {
  width: 1rem;
  height: 1rem;
}

.action-btn.mark-read {
  background: #dcfce7;
  color: #16a34a;
}

.action-btn.mark-read:hover {
  background: #bbf7d0;
  transform: scale(1.05);
}

.action-btn.delete {
  background: #fee2e2;
  color: #dc2626;
}

.action-btn.delete:hover {
  background: #fecaca;
  transform: scale(1.05);
}

.unread-indicator {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background: #f59e0b;
  border-radius: 50%;
  margin: 1rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 16px;
  border: 2px dashed #e2e8f0;
}

.empty-icon-container {
  width: 4rem;
  height: 4rem;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.empty-icon {
  width: 2rem;
  height: 2rem;
  color: #94a3b8;
}

.empty-state h3 {
  font-size: 1.5rem;
  color: #64748b;
  margin-bottom: 0.5rem;
}

.empty-state p {
  color: #94a3b8;
  max-width: 400px;
  margin: 0 auto;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 16px;
  margin-top: 2rem;
}

.loading-spinner {
  width: 3rem;
  height: 3rem;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #f59e0b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  color: #64748b;
  font-weight: 500;
}

@media (max-width: 768px) {
  .notification-container {
    padding: 1rem;
  }

  .notification-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
    padding: 1.5rem;
  }

  .header-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .title-content h1 {
    font-size: 1.5rem;
  }

  .mark-all-read-btn {
    align-self: stretch;
    text-align: center;
  }

  .notification-filters {
    flex-direction: column;
    gap: 0.25rem;
  }

  .filter-btn {
    text-align: center;
  }

  .notification-content {
    padding: 1rem;
  }

  .notification-main {
    gap: 0.75rem;
  }

  .notification-icon-wrapper {
    width: 2.5rem;
    height: 2.5rem;
  }

  .notification-title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .notification-meta {
    gap: 0.5rem;
  }

  .lead-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .notification-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .notification-actions {
    flex-direction: row;
    margin-left: 0;
    margin-top: 1rem;
  }
}

@media (max-width: 480px) {
  .notification-item.unread {
    border-left-width: 3px;
  }

  .notification-content {
    padding: 0.75rem;
  }

  .notification-main {
    flex-direction: column;
    gap: 1rem;
  }

  .notification-icon-wrapper {
    align-self: flex-start;
  }

  .notification-actions {
    justify-content: flex-end;
  }

  .remark-section {
    flex-direction: column;
    gap: 0.25rem;
  }
}

* {
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notification/notification.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;cACY;EACZ,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4DAA4D;AAC9D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;qEACmE;AACrE","sourcesContent":["Reset and Base Styles * {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n  background-color: #f8fafc;\n  color: #1e293b;\n  line-height: 1.6;\n}\n\n.notification-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem;\n  min-height: 100vh;\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 2rem;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  border-radius: 20px;\n  color: white;\n  box-shadow: 0 10px 25px rgba(245, 158, 11, 0.2);\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.bell-container {\n  position: relative;\n}\n\n.header-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.notification-badge {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: #ef4444;\n  color: white;\n  border-radius: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  border: 2px solid white;\n}\n\n.title-content h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.subtitle {\n  font-size: 1rem;\n  opacity: 0.9;\n  margin: 0.25rem 0 0 0;\n}\n\n.mark-all-read-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 10px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(10px);\n}\n\n.mark-all-read-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.notification-filters {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  background: white;\n  padding: 0.5rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.filter-btn {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  color: #64748b;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n}\n\n.filter-btn:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.filter-btn.active {\n  background: #f59e0b;\n  color: white;\n  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);\n}\n\n.notification-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.notification-item {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.notification-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border-color: #cbd5e1;\n}\n\n.notification-item.unread {\n  border-left: 4px solid #f59e0b;\n  background: linear-gradient(90deg, #fffbeb 0%, #ffffff 100%);\n}\n\n.notification-item.high {\n  border-left-color: #ef4444;\n}\n\n.notification-item.lead_alert {\n  border-top: 3px solid #f59e0b;\n}\n\n.notification-content {\n  padding: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.notification-main {\n  display: flex;\n  gap: 1rem;\n  flex: 1;\n}\n\n.notification-icon-wrapper {\n  flex-shrink: 0;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n}\n\n.notification-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.notification-icon.success {\n  color: #16a34a;\n}\n\n.notification-icon.warning {\n  color: #f59e0b;\n}\n\n.notification-icon.error {\n  color: #ef4444;\n}\n\n.notification-icon.info {\n  color: #3b82f6;\n}\n\n.notification-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  gap: 1rem;\n}\n\n.notification-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.notification-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.notification-time {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.time-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.priority-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.priority-badge.high {\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.lead-alert-details {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.lead-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  gap: 1rem;\n}\n\n.lead-name {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.lead-icon {\n  width: 1rem;\n  height: 1rem;\n  color: #64748b;\n}\n\n.lead-name-text {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 1rem;\n}\n\n.lead-status {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.status-followup {\n  background: #fef3c7;\n  color: #d97706;\n  border: 1px solid #fde68a;\n}\n\n.status-interested {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.status-not-interested {\n  background: #fee2e2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.status-callback {\n  background: #dbeafe;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n}\n\n.status-default {\n  background: #f1f5f9;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n\n.remark-section {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n}\n\n.remark-label {\n  font-weight: 600;\n  color: #64748b;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.remark-text {\n  color: #1e293b;\n  font-size: 0.875rem;\n  background: #ffffff;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  flex: 1;\n}\n\n.notification-description {\n  color: #475569;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n  font-size: 0.9rem;\n}\n\n.notification-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.sender-info,\n.notification-date {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.75rem;\n  color: #64748b;\n}\n\n.sender-icon,\n.date-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.sender-name {\n  font-weight: 600;\n}\n\n.notification-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-left: 1rem;\n}\n\n.action-btn {\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.action-btn svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.action-btn.mark-read {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.action-btn.mark-read:hover {\n  background: #bbf7d0;\n  transform: scale(1.05);\n}\n\n.action-btn.delete {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.action-btn.delete:hover {\n  background: #fecaca;\n  transform: scale(1.05);\n}\n\n.unread-indicator {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 8px;\n  background: #f59e0b;\n  border-radius: 50%;\n  margin: 1rem;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: white;\n  border-radius: 16px;\n  border: 2px dashed #e2e8f0;\n}\n\n.empty-icon-container {\n  width: 4rem;\n  height: 4rem;\n  background: #f1f5f9;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n}\n\n.empty-icon {\n  width: 2rem;\n  height: 2rem;\n  color: #94a3b8;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  color: #64748b;\n  margin-bottom: 0.5rem;\n}\n\n.empty-state p {\n  color: #94a3b8;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  background: white;\n  border-radius: 16px;\n  margin-top: 2rem;\n}\n\n.loading-spinner {\n  width: 3rem;\n  height: 3rem;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #f59e0b;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-container p {\n  color: #64748b;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .notification-container {\n    padding: 1rem;\n  }\n\n  .notification-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n    padding: 1.5rem;\n  }\n\n  .header-title {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .title-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .mark-all-read-btn {\n    align-self: stretch;\n    text-align: center;\n  }\n\n  .notification-filters {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .filter-btn {\n    text-align: center;\n  }\n\n  .notification-content {\n    padding: 1rem;\n  }\n\n  .notification-main {\n    gap: 0.75rem;\n  }\n\n  .notification-icon-wrapper {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .notification-title-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .notification-meta {\n    gap: 0.5rem;\n  }\n\n  .lead-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .notification-footer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .notification-actions {\n    flex-direction: row;\n    margin-left: 0;\n    margin-top: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .notification-item.unread {\n    border-left-width: 3px;\n  }\n\n  .notification-content {\n    padding: 0.75rem;\n  }\n\n  .notification-main {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .notification-icon-wrapper {\n    align-self: flex-start;\n  }\n\n  .notification-actions {\n    justify-content: flex-end;\n  }\n\n  .remark-section {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n}\n\n* {\n  transition: color 0.2s ease, background-color 0.2s ease,\n    border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
